import { combineReducers } from 'redux';
import activeAccount from './auth/activeAccount';
import errorHandling from './errorHandling/errorHandling';
import mainMenu from './mainMenu/mainMenu';
import myDashboard from './myDashboard/myDashboard';
import usersMap from './usersMap/usersMap';
import users from './users/users';
import companies from './companies/companies'
import posts from './posts/posts'
import sliders from './sliders/sliders'
import slides from './slides/slides';
import shareholderRights from './shareholderRights/shareholderRights';
import permissions from './permissions/permissions';
import roles from "./roles/roles"
import aboutus from './aboutus/aboutus';
import shareHolderEducation from './shareholderEducation/shareholderEducation';
import dashboard from './dashboard/dashboard';
import eServices from './eServices/eServices';
import complaintForms from './complaintForms/complaintForms';
export const rootReducer = combineReducers({
	myDashboard,
	dashboard,
	activeAccount,
	errorHandling,
	mainMenu,
	usersMap,
	users,
	companies,
	posts,
	sliders,
	slides,
	shareholderRights,
	permissions,
	roles,
	aboutus,
	shareHolderEducation,
	eServices,
	complaintForms,
});
